import { useEffect, useRef, useState } from "react";
import { BsBuildings, BsStack } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import errorImage from "../../assets/images/error.png";
import loader from "../../assets/images/loader.gif";
import nodata from "../../assets/images/nodata.png";
import {
  getAllProductsProfile,
  getProfessionalById,
} from "../../service/MainService";
import PagesHeading from "../common/PagesHeading";
import Pagination from "../common/Pagination";
import ProductCards from "./ProductCards";
import  ProductFilter  from "./ProductFilter";

const ProductList = () => {
  const navigate = useNavigate();
  const [productsProfile, setProductsProfile] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [productUserTotal, setProductUserTotal] = useState(null);
  const topRef = useRef(null);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const productsData = await getAllProductsProfile(currentPage, 10, filters);
        setProductsProfile(productsData.Result);
        setProductUserTotal(productsData.TotalProductUsers);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage, filters]);

  const navigateToProductUserDetail = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const userDetails = await getProfessionalById(userId, token);
      navigate(`/product-profile/${userId}`, {
        state: { userDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const handleFilterChange = (selectedFilters) => {
    setFilters(selectedFilters);
    console.log(selectedFilters);
  };



  return (
    <>
      <PagesHeading
        title={"Products"}
        subtitle={`${productUserTotal} registered products profiles`}
        description={
          "Find suppliers and distributors of products in the construction sector in the specialized directory Balarch. The best brands and suppliers of construction materials for your architectural project."
        }
      />
      <ProductCards productsProfile={productsProfile} />

      <div
        className="grid grid-cols-1 gap-10 lg:grid-cols-8 mt-20 mb-10"
        ref={topRef}
      >
        <div className="lg:col-span-2">
          <ProductFilter  onFilterChange={handleFilterChange}/>
        </div>

        <div className="lg:col-span-6">
          <div className="mb-5">
            <div className="flex  items-center">
              <div className="text-gray-700 text-md capitalize font-semibold pl-4">
                {productUserTotal} suppliers found
              </div>
            </div>
          </div>
          <hr />

          <div>
            {loading ? (
              <div className="flex justify-center items-center h-screen">
                <img src={loader} alt="Loading" />
              </div>
            ) : error ? (
              <div className="flex justify-center items-center h-screen">
                <img src={errorImage} alt="Error loading data" />
              </div>
            ) : productsProfile.length === 0 ? (
              <div className="flex justify-center items-center h-screen">
                <img src={nodata} alt="no data" />
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-4 mt-5 sm:grid-cols-2 lg:grid-cols-1">
                {productsProfile.map((product, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center bg-white border-2 border-gray-200 rounded-lg shadow md:flex-row  dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
                  >
                    <img
                      className="rounded-full my-5 mx-5 shadow-lg w-32 h-32"
                      src={product.ProfilePicture}
                      alt="Extra large avatar"
                    />
                    <div className="flex flex-col justify-between p-4 leading-normal">
                      <div className="flex items-center">
                        <div className="text-xl font-semibold pr-4">
                          {product.Name}
                        </div>
                        <div className="text-gray-500 font-semibold pl-4">
                          {product.ProfessionPositionName}
                        </div>
                      </div>
                      <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                        {product.ShortBio &&
                          product.ShortBio.split(" ")
                            .slice(0, 20)
                            .join(" ")}{" "}
                        {product.ShortBio &&
                        product.ShortBio.split(" ").length > 20
                          ? "..."
                          : ""}
                      </p>
                      <div className="grid grid-cols-3 gap-4 mt-5 sm:grid-cols-2 lg:grid-cols-3">
                        <div className="flex items-center gap-4 text-sm font-medium">
                          <CiLocationOn className="text-lg" />
                          <span>{product?.Country?.countryName}</span>
                        </div>
                        <div className="flex items-center gap-4 text-sm">
                          <BsStack className="text-lg" />
                          <span>+500 products</span>
                        </div>
                        <div className="flex items-center gap-4 text-sm">
                          <BsBuildings className="text-lg" />
                          <span>{product.Industry}</span>
                        </div>
                      </div>
                      <div className="flex w-full md:w-auto gap-4 my-5 mt-5">
                        <button
                          class="text-white bg-gray-800 hover:bg-neutral-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium text-sm px-3 py-1.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                          onClick={() =>
                            navigateToProductUserDetail(product.UserId)
                          }
                        >
                          View profile
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {productUserTotal > 10 && (
            <Pagination
              currentPage={currentPage}
              totalItems={productUserTotal}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProductList;
